import {
  classNames,
  statusColors,
  workflowStepIndicator
} from "../../utils/formatters";

import AdvancePaymentStatus from "../AdvancePaymentStatus";

const ApplicationStatusPanel = ({ submission, handleAction }: any) => {

  console.log('ApplicationStatusPanel', submission);

  return (
    <div className="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 mb-8">
      <div className="px-4 py-5 sm:px-6 bg-gray-50">
        <h2 className="font-bold text-gray-700">Application Status</h2>
      </div>
      <div className="px-4 py-5 sm:p-6">
        <div className="mb-2 font-semibold">Current Status</div>
        <span
          className={classNames(
            statusColors[submission.status],
            "px-4 py-3 inline-flex w-full justify-center leading-5 font-semibold rounded shadow-sm mb-4"
          )}
        >
          {submission.status}
        </span>
        {submission.advancePaymentEnabled && (
          <AdvancePaymentStatus
            submission={submission}
            handleAction={handleAction}
          />
        )}
        <div className="mb-2 font-semibold">Current Step</div>
        <div className="mb-4">{workflowStepIndicator(submission)}</div>
      </div>
    </div>
  );
};

export default ApplicationStatusPanel;
